import { render, staticRenderFns } from "./NavV2.vue?vue&type=template&id=43b3e458&scoped=true"
import script from "./NavV2.vue?vue&type=script&lang=ts"
export * from "./NavV2.vue?vue&type=script&lang=ts"
import style0 from "./NavV2.vue?vue&type=style&index=0&id=43b3e458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3e458",
  null
  
)

export default component.exports